import React, { createRef, useEffect, useRef, useState } from "react";
import { TextBox } from "@progress/kendo-react-inputs";
import { useLocation, useNavigate } from "react-router";
import { REWARDS_OPERATORS_LIST } from "../../../routes";
import moment from "moment";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
import api from "../../../config/api";
import { Loader } from "@progress/kendo-react-indicators";
import config from "../../../config/config";
import { useDispatch, useSelector } from "react-redux";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import "../rewards.css";
import { Button } from "@progress/kendo-react-buttons";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { fetchAllProviderList, fetchOperatorDetails, fetchPOCUserList, saveRewardsOperator, updateRewardsOperator } from "../../../store/rewardsOperator";
import { filterBy } from '@progress/kendo-data-query';

export const RewardsOperatorCreate = () => {
  const dispatch = useDispatch();
  const [selectedProvider, setSelectedProvider] = useState({});
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [officerName, setOfficerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emailerror, setEmailError] = React.useState("");
  const [emailtouched, setEmailTouched] = React.useState(false);
  const [mobileNumberError, setMobileNumberError] = React.useState("");
  const [mobileNumberTouched, setMobileNumberTouched] = React.useState(false);
  const [selectedPocUser, setSelectedPocUser] = useState(null);
  const [pocUsersCombo, setPocUsersCombo] = useState([]);

  const { provider_loading, provide_list, provider_error, save_loading, detail_data, detail_loading, poc_user_list } = useSelector((state) => state.rewardsOperator);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const navigate = useNavigate();
  const userPermissions = getUserPermission();
  const AddPermssion = checkPermission(
    userPermissions,
    "gamifications.create_campaign_operator"
  );
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const sgMobileRegex = /^(?:\+65)?[689]\d{7}$/;

  useEffect(() => {
    dispatch(fetchPOCUserList())
    dispatch(fetchAllProviderList());
    if (id) {
      dispatch(fetchOperatorDetails(id));
    }
  }, [])
  useEffect(() => {
    if (detail_data && id) {
      setSelectedPocUser({ poc_id: detail_data?.poc_id, poc_name: detail_data?.poc_name })
      setName(detail_data?.name);
      setAddress(detail_data?.address);
      setOfficerName(detail_data?.officer_name);
      setEmail(detail_data?.email);
      setMobileNumber(detail_data?.contact_no);
      setSelectedProvider({
        'pk': detail_data?.provider_id,
        'name': detail_data?.provider_name
      });
    }
  }, [detail_data])

  useEffect(() => {
    setPocUsersCombo(poc_user_list);
  }, [poc_user_list])

  const handleSubmit = ((e) => {
    e.preventDefault();
    let data = {
      'provider_id': selectedProvider['pk'],
      'provider_name': selectedProvider['name'],
      'name': name,
      'address': address,
      'officer_name': officerName,
      'email': email,
      'contact_no': mobileNumber,
      'poc_id': selectedPocUser?.poc_id || '',
      'poc_name': selectedPocUser?.poc_name || '',
    }
    if (id) {
      data["id"] = id;
      dispatch(updateRewardsOperator(data)).then((res) => {
        navigate(REWARDS_OPERATORS_LIST);
      });
    }
    else {
      dispatch(saveRewardsOperator(data)).then((res) => {
        navigate(REWARDS_OPERATORS_LIST);
      });
    }

  });
  const validateEmail = (value) => {
    if (!value) {
      return "";
    }
    if (!emailRegex.test(value)) {
      return "Invalid email address.";
    }
    return "";
  };
  const handleBlur = () => {
    setEmailTouched(true);
    const validationResult = validateEmail(email);
    setEmailError(validationResult);
  };

  const onChangeEmail = ((e) => {
    const value = e.value;
    setEmail(value);
    setEmailTouched(true);

    // Validate as user types
    const validationResult = validateEmail(value);
    setEmailError(validationResult);
  });

  const validateMobileNumber = (value) => {
    if (!value) {
      return "";
    }
    if (!sgMobileRegex.test(value)) {
      return "Invalid contact number.";
    }
    return "";
  };
  const handleMobileNumberBlur = () => {
    setMobileNumberTouched(true);
    const validationResult = validateMobileNumber(mobileNumber);
    setMobileNumberError(validationResult);
  };

  const onChangeMobileNumber = ((e) => {
    const value = e.value;
    setMobileNumber(value);
    setMobileNumberTouched(true);

    // Validate as user types
    const validationResult = validateMobileNumber(value);
    setMobileNumberError(validationResult);
  });

  const filterChange = (event) => {

    // Extract typed text safely
    const filterText = String(event.filter?.value ?? '').toLowerCase();
    
    const filtered = poc_user_list.filter(item => {
      const idStr = String(item.poc_id).toLowerCase();
      const nameStr = (item.poc_name || '').toLowerCase();
      return idStr.includes(filterText) || nameStr.includes(filterText);
    });

    setPocUsersCombo(filtered);
  };

  const handleChange = (event) => {
    // The selected value is in event.value
    setSelectedPocUser(event.target.value);
    console.log("Selected value:", event.target.value);
  };


  const isValid = !validateEmail(email);

  return (
    <>
      {AddPermssion ? (
        <div>
          {provider_loading || save_loading || detail_loading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 96px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <>
              <div
                className="rewards_create_header"
              >
                <div
                  className="rewards_create_back"
                  onClick={() => navigate(REWARDS_OPERATORS_LIST)}
                >
                  <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                  Back
                </div>
              </div>
              <form>
                <div className="rewards-form-contents">
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Rewards Providers</span>
                    <div className="reward_add_dropdown">
                      <DropDownList
                        data={provide_list}
                        value={selectedProvider}
                        dataItemKey={`pk`}
                        textField={`name`}
                        size={"large"}
                        onChange={(e) => setSelectedProvider(e.target.value)}
                        iconColor="#73007D"
                        iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                      />
                    </div>
                  </div>
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Location</span>
                    <TextBox className="rewards-form-textbox" onChange={(e) => setName(e.target.value)} value={name} />
                  </div>
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Location Address</span>
                    <TextBox className="rewards-form-textbox" onChange={(e) => setAddress(e.target.value)} value={address} />
                  </div>
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Operator Name</span>
                    <TextBox className="rewards-form-textbox" onChange={(e) => setOfficerName(e.target.value)} value={officerName} />
                  </div>
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Operator Email Address</span>
                    <TextBox
                      className="rewards-form-textbox"
                      value={email}
                      onChange={onChangeEmail}
                      onBlur={handleBlur}
                      style={emailtouched && emailerror ? { borderColor: "red" } : {}}
                    />
                    {emailtouched && emailerror && (
                      <span style={{ color: "red", marginTop: "0px" }}>{emailerror}</span>
                    )}
                  </div>
                  <div className="rewards-form-row">
                    <span className="rewards-form-title">Contact Number</span>
                    <TextBox
                      className="rewards-form-textbox"
                      value={mobileNumber}
                      onChange={onChangeMobileNumber}
                      onBlur={handleMobileNumberBlur}
                      style={mobileNumberTouched && mobileNumberError ? { borderColor: "red" } : {}}
                    />
                    {mobileNumberTouched && mobileNumberError && (
                      <span style={{ color: "red", marginTop: "0px" }}>{emailerror}</span>
                    )}
                  </div>

                  <div className="rewards-form-row">
                    <div className="rewards-form-title">
                      Officer Name
                    </div>

                    <div className="operator">

                      <ComboBox
                        id="operators"
                        data={pocUsersCombo}
                        textField="poc_name"
                        dataItemKey="poc_id"
                        filterable={true}
                        onFilterChange={filterChange}
                        style={{
                          width: '100%'
                        }}
                        onChange={handleChange}
                        value={selectedPocUser}
                        placeholder="Choose POC Name"
                        itemRender={(li, itemProps) => {
                          const item = itemProps.dataItem || {}
                          const id = item.poc_id ?? '-'
                          const name = item.poc_name?.trim() ? item.poc_name : '-'
                          return React.cloneElement(li, li.props, `${name} (${id})`)
                        }}

                      />

                    </div>

                  </div>
                </div>
                <div className="rewards-form-footer">
                  <Button className="cancel" onClick={() => { navigate(REWARDS_OPERATORS_LIST); }}>Cancel</Button>
                  <Button
                    type="submit"
                    className="submit"
                    onClick={handleSubmit}
                    disabled={!isValid}>Submit</Button>
                </div>
              </form>
            </>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
